
import React, { useContext, useEffect } from "react"
import './InteractiveMap.css';
import {  MapItem, WeeklyActivity } from "../Shared/Map/MapData";
import { GeoBounds, GeoLabel } from "../Shared/GeoData/GeoObject";
import { InstantActivity } from "../Shared/Schedule/ScheduleActivity";
import { StateManagerContext } from "../widgets/StateManagerContext";
import { StateManager } from "../widgets/PartyState";




const StateLabelDisplay = ({ text, x, y }: GeoLabel): React.JSX.Element => {

    return (<text x={x} y={y} className="stateLabel">{text}</text>);

}

type StatePathProps = {
    stateId: string,
    path: string,
    activity: number,
    select(region: string): void;
}


const StatePath = ({ stateId, path, activity, select }: StatePathProps): React.JSX.Element => {

    const cssClass = "MapStateActivity" + activity;

    return (<path d={path} id={"STATE" + stateId} className={cssClass} pointerEvents="all" onClick={() => { select(stateId); }}></path>);
}

const getMapBounds = (mapData: WeeklyActivity): GeoBounds => {
    var minX = Number.MAX_VALUE;
    var minY = Number.MAX_VALUE;
    var maxX = Number.MIN_VALUE;
    var maxY = Number.MIN_VALUE;

    mapData.items.map((mapItem: MapItem) => {
        const bounds = mapItem.geo.bounds;
        minX = Math.min(minX, bounds.x);
        maxX = Math.max(maxX, bounds.x2);
        minY = Math.min(minY, bounds.y);
        maxY = Math.max(maxY, bounds.y2);
    });

    return {
        x: minX,
        y: minY,
        x2: maxX,
        y2: maxY
    }
}

type StateMapProps = {
    mapData: WeeklyActivity,
    activity : InstantActivity,
    width: number,
    selectRegion(region: string): void;
}

const StateMap = ({ mapData, activity, width, selectRegion }: StateMapProps): React.JSX.Element => {

    const mapBounds = getMapBounds(mapData);
    const scaleFactor = Math.min((0.9 * width) / (mapBounds.x2 - mapBounds.x));
    const gap = 0.0125 * (mapBounds.x2 - mapBounds.x);

    const labelDefs = new Array<GeoLabel>();

    var pillCount = 0;


    const transform = "translate(-" + mapBounds.x + " -" + mapBounds.y + ") scale(" + scaleFactor + ")";

    return (<g transform={transform}>
        <rect x={mapBounds.x} y={mapBounds.y} width={mapBounds.x2 - mapBounds.x} height={mapBounds.y2 - mapBounds.y} fill="#131313" onClick={() => {
            selectRegion('US');
        }}></rect>
        {
            mapData.items.map((mapItem: MapItem) => {
                const geo = mapItem.geo;
                const state = activity.states[geo.id];
                const stateLevel = activity.stateLevels[geo.id];
                var path = "";
                if (geo.label.outline !== undefined) {

                    const ox = geo.label.x + geo.label.outline.x;
                    const oy = geo.label.y + geo.label.outline.x;
                    const radius = geo.label.outline.width * 0.5;

                    const pp = " M " + ox + " " + oy +
                        " a " + radius + " " + radius + " 0 0 1 " + radius + " -" + radius +
                        " a " + radius + " " + radius + " 0 0 1 " + radius + " " + radius +
                        " a " + radius + " " + radius + " 0 0 1 -" + radius + " " + radius +
                        " a " + radius + " " + radius + " 0 0 1 -" + radius + " -" + radius + "z";
                    path = geo.path + pp;
                    //console.log("Pill Label" + pillCount + " (" + geo.label.outline.x + "," + geo.label.outline.y + "," + radius + ")");
                    pillCount++;
                }
                else {
                    path = geo.path;
                }

                labelDefs.push(geo.label);
                return (<StatePath key={'InteractiveMapStatePath' + geo.id} stateId={geo.id} select={selectRegion} path={path} activity={stateLevel} />);
            })
        }
        {
            labelDefs.map((label: GeoLabel, index : number) => {
                return (<StateLabelDisplay key={'InteractiveMapStateLabel' + index} {...label} />)
            })
        }

    </g>)

}



export type InteractiveMapProps = {
    idPrefix: string;
    moreDataRequest(region: string): void;
}


export const InteractiveMap = ({ idPrefix: idPrefix, moreDataRequest }: InteractiveMapProps): React.JSX.Element => {
    const stateManager = useContext(StateManagerContext);
    const activity = stateManager.activity();
    const mapData = stateManager.weeklyActivity();

    const userCountDisplay = React.useRef<null | HTMLSpanElement>(null);
    const overlayPanel = React.useRef<null | HTMLDivElement>(null);
    const overlayStateName = React.useRef<null | HTMLSpanElement>(null);
    const overlayUserCountDisplay = React.useRef<null | HTMLSpanElement>(null);
    const selectedRegion = React.useRef<string>('US');
    const notifyId = React.useRef<number>(-1);

    

    //const mapStateRef = React.useRef<MapState>(InitialiseMapState(mapData, Date.now()));
   // const initTimer = React.useRef<boolean>(false);


    const mapBounds = getMapBounds(mapData);
    const scaleFactor = Math.min((0.9 * 600) / (mapBounds.x2 - mapBounds.x));

    const svgId = idPrefix + "_SVGRoot";

    const moreDataRequestClick = (region: string) => {
        if (overlayPanel.current !== null)
            overlayPanel.current.style.visibility = 'hidden';
        moreDataRequest(region);


    }

    /*const runUserCounts = () => {
        UpdateMapState(mapData, Date.now(), mapStateRef.current)
        if (userCountDisplay.current !== null)
            userCountDisplay.current.innerHTML = mapStateRef.current.currentUsers + " Fans Online";
    }*/

    const updateUserCounter = (state : StateManager) => {
        const updatedActivity = state.activity();
        if (userCountDisplay.current !== null)
            userCountDisplay.current.innerHTML = updatedActivity.national + " Fans Online";
    }

    if(notifyId.current === -1)
        {
            const nid = Math.random();
            stateManager.addNotifyMainUpdateFunction(nid,updateUserCounter)
            notifyId.current = nid;
        }

    useEffect(() => {
        userCountDisplay.current = document.getElementById(idPrefix + "_UserCountDisplay") as HTMLSpanElement;
        overlayPanel.current = document.getElementById(idPrefix + "_OverlayPanel") as HTMLDivElement;
        overlayStateName.current = document.getElementById(idPrefix + "_Overlay_StateName") as HTMLSpanElement;
        overlayUserCountDisplay.current = document.getElementById(idPrefix + "_Overlay_UserCountDisplay") as HTMLSpanElement;
        return () => {if(notifyId.current !== -1) stateManager.removeNotifyMainUpdateFunction(notifyId.current);}

        /*if (!initTimer.current) {
            initTimer.current = true;
            window.setInterval(runUserCounts, 60000);
        }*/
    })

    const selectRegion = (region: string) => {
        selectedRegion.current = region;
        if (overlayPanel.current !== null) {
            if (region !== 'US') {
                for (let i = 0; i < mapData.items.length; i++) {
                    if (mapData.items[i].geo.id === region) {
                        const item = mapData.items[i];
                        const left = item.geo.label.x * scaleFactor - 60;
                        const top = item.geo.label.y * scaleFactor - 40;
                        overlayPanel.current.style.left = left + 'px';
                        overlayPanel.current.style.top = top + 'px';
                        if (overlayStateName.current !== null)
                            overlayStateName.current.innerHTML = item.geo.name;
                        if (overlayUserCountDisplay.current !== null)
                            overlayUserCountDisplay.current.innerHTML = activity.states[region] + " Online";
                    }

                }

                overlayPanel.current.style.visibility = "visible";
            }
            else {
                overlayPanel.current.style.visibility = 'hidden';

            }

        }
    }


    return (
        <div style={{
            width: "675px",
            minWidth: "675px",
            maxWidth: "675px",
            height: "530px",
            minHeight: "530px",
            maxHeight: "530px",
            position: "relative",
            backgroundColor: "#131313",
            borderRadius: "25px",
        }}>

            <span id={idPrefix + "_UserCountDisplay"} style={{
                position: "absolute",
                top: "25px",
                left: "36px",
                fontSize: "32px",
                fontWeight: 700
            }}>{activity.national} Fans Online</span>
            <span style={{
                position: "absolute",
                top: "65px",
                left: "131px",
                fontSize: "12px",
                fontWeight: 400
            }}>Click a state for detailed data</span>

            <svg height="340" width="600" id={svgId} style={{
                position: "absolute",
                top: "80px",
                left: "24px"
            }}>
                <StateMap mapData={mapData} activity={activity} selectRegion={selectRegion} width={600} />

            </svg>
            <div id={idPrefix + "_OverlayPanel"} style={{ position: "absolute", visibility: "hidden", backgroundColor: 'white', display: 'flex', flexDirection: 'column', width: "160px", minWidth: "160px", maxWidth: "160px", height: "100px", minHeight: "100px", maxHeight: "100px", borderRadius: "12.5px" }}>
                <span id={idPrefix + "_Overlay_StateName"} style={{ color: 'black', fontSize: "20px", fontWeight: 700, marginTop: "10px" }}></span>
                <span id={idPrefix + "_Overlay_UserCountDisplay"} style={{ color: 'black', fontSize: "16px", fontWeight: 400, position: "relative", top: "-4px" }}></span>
                <a href="#DataDisplayPanel" style={{ textDecoration: 'none' }}>
                    <div style={{ backgroundColor: '#D6C137', borderRadius: "10px", minHeight: "20px", height: "20px", maxHeight: "20px", width: "100px", maxWidth: "100px", minWidth: "100px", marginLeft: "30px" }} onClick={() => { moreDataRequestClick(selectedRegion.current); }}><span style={{ color: 'black', fontSize: "12px", fontWeight: 400, position: "relative", top: "-4px" }} onClick={() => { moreDataRequest(selectedRegion.current); }}>View all data</span></div>
                </a>
            </div>
        </div>
    );

}

/*
 <div style={{
                position: "absolute",
                top: "21px",
                left: "475px",
                width: "174px",
                minWidth: "174px",
                maxWidth: "174px",
                height: "48px",
                minHeight: "48px",
                maxHeight: "48px",
            }}>
                <div style={{
                position: "absolute",
                top: "0px",
                left: "3px",
                width: "48px",
                minWidth: "48px",
                maxWidth: "48px",
                height: "48px",
                minHeight: "48px",
                maxHeight: "48px",
                backgroundColor : "#070501"
            }}>
                <img src={s3URL + "map.png"}  style={{
                    position: "absolute",
                    top: "5px",
                    left: "12px",
                    width: "24px",
                    minWidth: "24px",
                    maxWidth: "24px",
                    height: "24px",
                    minHeight: "24px",
                    maxHeight: "24px",
                }}/>
                <span style={{
                    position: "absolute",
                    top: "32px",
                    left: "1px",
                    width: "46px",
                    minWidth: "46px",
                    maxWidth: "46px",
                    textAlign : "center",
                    fontSize : "10px",
                    fontWeight : 400
                }}>MAP</span>
            </div>
            <div style={{
                position: "absolute",
                top: "0px",
                left: "63px",
                width: "48px",
                minWidth: "48px",
                maxWidth: "48px",
                height: "48px",
                minHeight: "48px",
                maxHeight: "48px",
                backgroundColor : "#070501"
            }}>
                <img src={s3URL + "data.png"} style={{
                    position: "absolute",
                    top: "5px",
                    left: "12px",
                    width: "24px",
                    minWidth: "24px",
                    maxWidth: "24px",
                    height: "24px",
                    minHeight: "24px",
                    maxHeight: "24px",
                }}/>
                <span style={{
                    position: "absolute",
                    top: "32px",
                    left: "1px",
                    width: "46px",
                    minWidth: "46px",
                    maxWidth: "46px",
                    textAlign : "center",
                    fontSize : "10px",
                    fontWeight : 400
                }}>DATA</span>
            </div>
            <div style={{
                position: "absolute",
                top: "0px",
                left: "123px",
                width: "48px",
                minWidth: "48px",
                maxWidth: "48px",
                height: "48px",
                minHeight: "48px",
                maxHeight: "48px",
                backgroundColor : "#070501"
            }}>
                <img src={s3URL + "expand.png"}  style={{
                    position: "absolute",
                    top: "5px",
                    left: "12px",
                    width: "24px",
                    minWidth: "24px",
                    maxWidth: "24px",
                    height: "24px",
                    minHeight: "24px",
                    maxHeight: "24px",
                }}/>
                <span style={{
                    position: "absolute",
                    top: "32px",
                    left: "1px",
                    width: "46px",
                    minWidth: "46px",
                    maxWidth: "46px",
                    textAlign : "center",
                    fontSize : "10px",
                    fontWeight : 400
                }}>EXPAND</span>
            </div>
            </div>

*/




/*

const renderBar = (svg: SVGElement, barData: ChartData, xpos: number, ypos: number) => {
    const indexes = [];
    for (let i = 0; i < barData.data.length; i++) {
        indexes.push([barData.data[i].value, i]);
    }

    indexes.sort((a, b) => b[0] - a[0]);

    var g = document.createElementNS('http://www.w3.org/2000/svg', "g");
    g.setAttribute("transform", "translate(" + xpos + "," + ypos + ")");
    svg.appendChild(g);

    var titleText = document.createElementNS('http://www.w3.org/2000/svg', "text");
    titleText.textContent = barData.title;
    titleText.setAttribute("x", "0");
    titleText.setAttribute("y", "20");
    titleText.setAttribute("class", "headingText");
    g.appendChild(titleText);

    var yAxis = document.createElementNS('http://www.w3.org/2000/svg', "line");
    yAxis.setAttribute("x1", "0");
    yAxis.setAttribute("x2", "0");
    yAxis.setAttribute("y1", "25");
    yAxis.setAttribute("y2", "175");
    yAxis.setAttribute("stroke", "black");
    g.appendChild(yAxis);

    var xAxis = document.createElementNS('http://www.w3.org/2000/svg', "line");
    xAxis.setAttribute("x1", "0");
    xAxis.setAttribute("x2", "" + (indexes.length * 25));
    xAxis.setAttribute("y1", "175");
    xAxis.setAttribute("y2", "175");
    xAxis.setAttribute("stroke", "black");
    g.appendChild(xAxis);

    for (let i = 0; i < indexes.length; i++) {
        var bar = document.createElementNS('http://www.w3.org/2000/svg', "rect");
        const x = 5 + i * 25;
        bar.setAttribute("x", "" + x);
        bar.setAttribute("width", "15");
        const height = 100 * (indexes[i][0] - 0.5);
        bar.setAttribute("y", "" + (175 - height));
        bar.setAttribute("height", "" + height);
        var classNumber = Math.round((indexes[i][0] - 0.5) / 1.5 * 6);
        bar.setAttribute("class", "graphSegment" + classNumber);
        g.appendChild(bar);

        var text = document.createElementNS('http://www.w3.org/2000/svg', "text");
        text.textContent = barData.data[indexes[i][1]].name;
        text.setAttribute("x", "0");
        text.setAttribute("y", "0");
        text.setAttribute("transform", "rotate(90) translate(185,-" + (x + 2) + ")");
        text.setAttribute("class", "barLabel");
        g.appendChild(text);

        var valueLabel = document.createElementNS('http://www.w3.org/2000/svg', "text");
        const index = Math.round(indexes[i][0] * 100);
        valueLabel.textContent = index + "i";
        valueLabel.setAttribute("x", index < 100 ? "" + x : "" + (x - 4));
        valueLabel.setAttribute("y", "" + (173 - height));
        valueLabel.setAttribute("class", "barLabel");
        g.appendChild(valueLabel);


    }

}

const renderSingleBar = (svg: SVGElement, data: ChartData, xpos: number, ypos: number, width: number) => {

    var g = document.createElementNS('http://www.w3.org/2000/svg', "g");
    g.setAttribute("transform", "translate(" + xpos + "," + ypos + ")");
    svg.appendChild(g);

    var titleText = document.createElementNS('http://www.w3.org/2000/svg', "text");
    titleText.textContent = data.title;
    titleText.setAttribute("x", "0");
    titleText.setAttribute("y", "20");
    titleText.setAttribute("class", "headingText");
    g.appendChild(titleText);

    var totalValue = 0;
    for (let i = 0; i < data.data.length; i++) {
        totalValue += data.data[i].value;
    }

    const sf = width / totalValue;

    totalValue = 0;

    for (let i = 0; i < data.data.length; i++) {
        var bar = document.createElementNS('http://www.w3.org/2000/svg', "rect");
        const width = sf * data.data[i].value;
        bar.setAttribute("x", "" + totalValue);
        bar.setAttribute("width", "" + width);
        bar.setAttribute("y", "25");
        bar.setAttribute("height", "20");
        bar.setAttribute("class", "graphSegment" + i);
        g.appendChild(bar);

        var text = document.createElementNS('http://www.w3.org/2000/svg', "text");
        text.textContent = data.data[i].name;
        text.setAttribute("x", "0");
        text.setAttribute("y", "40");
        text.setAttribute("class", "barLabel");
        g.appendChild(text);

        const ctextLen = text.getComputedTextLength();
        text.setAttribute("x", "" + (totalValue + 0.5 * (width - ctextLen)));
        totalValue += width;

    }



}

const renderDonut = (svg: SVGElement, data: ChartData, xpos: number, ypos: number, width: number) => {

    var g = document.createElementNS('http://www.w3.org/2000/svg', "g");
    g.setAttribute("transform", "translate(" + xpos + "," + ypos + ")");
    svg.appendChild(g);

    const radius = width * 0.5;
    const innerRadius = 0.5 * radius;
    const txtRadius = radius + 10;
    var total = 0;
    for (let i = 0; i < data.data.length; i++) {
        total += data.data[i].value;
    }

    var factor = 2 * Math.PI / total;

    var theta = -Math.PI * 0.5;
    const cx = radius;
    const cy = radius;

    var ctext = document.createElementNS('http://www.w3.org/2000/svg', "text");
    ctext.textContent = data.title;
    ctext.setAttribute("x", "" + cx);
    ctext.setAttribute("y", "" + (cy + 5));
    ctext.setAttribute("class", "headingText");
    g.appendChild(ctext);

    const ctextLen = ctext.getComputedTextLength();
    ctext.setAttribute("x", "" + (cx - 0.5 * ctextLen));



    for (let i = 0; i < data.data.length; i++) {
        const span = data.data[i].value * factor;
        const endTheta = theta + span
        const txtTheta = theta + 0.5 * span;

        const p1 = [Math.round(cx + Math.cos(endTheta) * radius), Math.round(cy + Math.sin(endTheta) * radius)];
        const p2 = [Math.round(cx + Math.cos(endTheta) * innerRadius), Math.round(cy + Math.sin(endTheta) * innerRadius)];
        const p3 = [Math.round(cx + Math.cos(theta) * innerRadius), Math.round(cy + Math.sin(theta) * innerRadius)];
        const p4 = [Math.round(cx + Math.cos(theta) * radius), Math.round(cy + Math.sin(theta) * radius)];
        const pt = [Math.round(cx + Math.cos(txtTheta) * txtRadius), Math.round(cy + Math.sin(txtTheta) * txtRadius)];
        const arcflag = span > Math.PI ? 1 : 0;

        const m = "M " + p4[0] + " " + p4[1];
        const a1 = "A " + radius + " " + radius + " 0 " + arcflag + " 1 " + p1[0] + " " + p1[1];

        const l1 = "L " + p2[0] + " " + p2[1];

        const a2 = "A " + innerRadius + " " + innerRadius + " 0 " + arcflag + " 0 " + p3[0] + " " + p3[1];

        const l2 = "L " + p4[0] + " " + p4[1];

        const pathString = m + " " + a1 + " " + l1 + " " + a2 + " " + l2;
        var path = document.createElementNS('http://www.w3.org/2000/svg', "path");
        path.setAttribute("d", pathString);
        path.setAttribute("id", "DP_" + data.data[i].name);
        path.setAttribute("class", "graphSegment" + i);
        path.setAttribute("pointer-events", "none");
        g.appendChild(path);

        var text = document.createElementNS('http://www.w3.org/2000/svg', "text");
        text.textContent = data.data[i].name;
        text.setAttribute("x", "" + pt[0]);
        text.setAttribute("y", "" + pt[1]);
        text.setAttribute("class", "labelText");
        g.appendChild(text);

        if ((theta < (-Math.PI * 0.5)) || (theta > (0.5 * Math.PI))) {
            const tlength = text.getComputedTextLength();
            text.setAttribute("x", "" + (pt[0] - tlength));

        }



        theta = endTheta;

    }

}


*/